import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const [formData, setFormData] = useState({
    user_email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://laravel-api.aj-mart.com/api/login",
        formData
      );

      if (response.data.status) {
        const token = response.data.data.token;
        sessionStorage.setItem("authToken", token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        // Show success toast
        toast.success("Login successful! Redirecting...", {
          position: "top-left",
          autoClose: 1000,
        });

        // Redirect after 1 second
        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      } else {
        toast.error(response.data.message || "Invalid Email or Password ", {
          position: "top-left",
          autoClose: 1000,
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.", {
        position: "top-left",
        autoClose: 2000,
      });
    }
  };

  return (
    <section className="h-full bg-[#1485a6]">
      <div className="container h-full flex items-center justify-center">
        <div className="bg-white p-[30px] rounded-[16px] flex flex-col gap-[25px] w-[400px] h-[500px]">
          <div className="flex items-center justify-center">
            <img
              className="w-[130px]"
              src={require("../assets/logo/logo.svg").default}
              alt="Logo"
            />
          </div>
          <div className="text-[#1485a6] font-bold text-[22px] text-center">
            Login for Authenticate
          </div>

          <form className="flex flex-col gap-[20px]" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-[5px]">
              <label className="text-[18px] text-[#1485a6] font-bold capitalize">
                Email
              </label>
              <input
                type="text"
                name="user_email"
                value={formData.user_email}
                onChange={handleChange}
                className="p-[10px] rounded-[4px] border-[1px] border-[#1485a6] outline-none text-black"
                placeholder="Email"
                required
              />
            </div>
            <div className="flex flex-col gap-[5px]">
              <label className="text-[18px] text-[#1485a6] font-bold capitalize">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="p-[10px] rounded-[4px] border-[1px] border-[#1485a6] outline-none text-black"
                placeholder="Password"
                required
              />
            </div>
            <button
              className="bg-[#1485a6] w-fit text-white font-bold py-2 px-7 rounded-[4px] text-[15px] capitalize mx-auto"
              type="submit"
            >
              Login
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
}
